import { render, staticRenderFns } from "./LargeFormatJob.vue?vue&type=template&id=bd31a07a&scoped=true&"
import script from "./LargeFormatJob.vue?vue&type=script&lang=js&"
export * from "./LargeFormatJob.vue?vue&type=script&lang=js&"
import style0 from "./LargeFormatJob.vue?vue&type=style&index=0&id=bd31a07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd31a07a",
  null
  
)

export default component.exports